import React from 'react';
import { OptionType } from '@ru-digital-assets/ui-component/dist/stories/ui/ui-select/ui-select';
import FormFooter from '../../../containers/form-footer';
import IconBtn from '../../../modules/icon-btn/icon-btn';
import UiSelect from '../../../modules/ui/ui-select/ui-select';
import SignIcon from './icons/sign-icon.svg';

interface SignFormProps {
  options: { value: string; label: string }[];
  onChangeCert: (certificate: OptionType | OptionType[] | undefined) => void;
  isDisabled?: boolean;
  onSubmit: () => void;
  selectedCert: OptionType | undefined;
  btnText?: string;
}

const SignForm: React.FC<SignFormProps> = ({
  options,
  isDisabled,
  onChangeCert,
  btnText,
  onSubmit,
  selectedCert,
}) => (
  <FormFooter>
    <form className="form-assets form-assets__container form-asset-credit__container">
      <div className="form-assets__flex">
        <div className="form-assets__item form-assets__item-432 form-assets__item--select">
          <UiSelect
            label="Выберите подпись"
            options={options}
            lg
            value={selectedCert}
            onChange={onChangeCert}
          />
        </div>
      </div>
      <div className="form-assets__item">
        <div className="form-item">
          <IconBtn
            onClick={onSubmit}
            lg
            disabled={isDisabled}
            icon={SignIcon}
            title={btnText ? btnText : 'Подписать'}
          />
        </div>
      </div>
    </form>
  </FormFooter>
);

export default SignForm;
